export default "__VITE_ASSET__mu2XbXRv__"